import React, { useState } from 'react';
import { Button, Col, Container, Form, FormCheck, FormControl, FormGroup, FormLabel, FormSelect, Row } from 'react-bootstrap';
import {countryList} from './CountryList';
import {useDispatch} from 'react-redux';
import {createReview} from '../../actions/review';

import './Review.css'
import ModalP from '../ModalP';
import { useNavigate } from 'react-router-dom';


function Review() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [reviewData,setReviewData]= useState({name:'',address:'',description:''});

    function handleChange(e){
        setReviewData({...reviewData,[e.target.name]: e.target.value});

    }
    function handleSubmit(e){
        e.preventDefault()
        

            dispatch(createReview(reviewData));
            navigate('/thanks');
    }

    return (
        <div >
            <Container className='Review-wrapper '>
                <Row>
                <Col xl={6} lg={6} md={6} sm={6} xs={12}  className='IntroDiv'>
                    <h3>Please share your experiences with us</h3>
                </Col>
                <Col xl={6} lg={6} md={6} sm={4} xs={12}  className='FormDiv'>
                <Form >
                    <FormGroup>
                        <FormLabel>Name</FormLabel>
                        <FormControl type='text' name='name' value={reviewData.name} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <FormLabel>Email</FormLabel>
                        {/* <FormSelect value={reviewData.address} name='address' onChange={handleChange} >
                            <option> India</option>
                            {countryList.map((pays,id)=>{
                                return <option key={id} value={pays}>{pays}</option>
                            })}
                            
                        </FormSelect> */}
                        <FormControl  type='email' name='address' value={reviewData.address} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        
                        <FormLabel>Comments/Questions</FormLabel>
                        <FormControl as='textarea' rows={5} name='description' value={reviewData.description} onChange={handleChange} />
                    </FormGroup>
                    <div style={{marginTop:'20px'}}>
                    <Button type='submit' variant='warning'  className='ReviewBtn w-100' onClick={handleSubmit}>Send Message</Button>
                    </div>
                </Form>
                
                </Col>
            </Row>
            </Container>
        </div>
    )
}

export default Review;
